import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  cancel36mj9lv3a0whl as cancel,
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  CoroutineScopelux7s7zphw7e as CoroutineScope_0,
} from '../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { delay1yesbzthrp6ln as delay } from '../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import {
  ApolloNetworkException3denf70pfh242 as ApolloNetworkException,
  SubscriptionConnectionException12fjxvnnqzby5 as SubscriptionConnectionException,
  ApolloWebSocketClosedException26hvn543pf46i as ApolloWebSocketClosedException,
  DefaultApolloException8w3ielfxng0h as DefaultApolloException,
} from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/exception/Exceptions.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { get_atomicfu$reentrantLock3o926yhldwf1 as get_atomicfu$reentrantLock } from '../../../../../../../kotlinx-atomicfu/kotlinx/atomicfu/locks/Synchronized.mjs';
import { Dispatchers_getInstance2p2r3ndn98nn as Dispatchers_getInstance } from '../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Dispatchers.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { HttpHeader1d7ldebjomr00 as HttpHeader } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/http/Http.mjs';
import { plus20p0vtfmu0596 as plus } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  ConnectionKeepAliveServerMessage_instance2ob2yorxvink1 as ConnectionKeepAliveServerMessage_instance,
  PongServerMessage_instance2myyosnalu8du as PongServerMessage_instance,
  PingServerMessage_instance3ap589ewmnnfp as PingServerMessage_instance,
  ParseErrorServerMessage28gxznaow3b26 as ParseErrorServerMessage,
  OperationErrorServerMessage3f3enfqsilvrv as OperationErrorServerMessage,
  CompleteServerMessage1c62v9ocjho2f as CompleteServerMessage,
  ResponseServerMessage1aifb0dqdz3sq as ResponseServerMessage,
  ConnectionErrorServerMessage21355wd69v8tf as ConnectionErrorServerMessage,
  ConnectionAckServerMessage_instance1tbiu51fjl5zr as ConnectionAckServerMessage_instance,
} from '../ServerMessage.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { println2shhhgwwt4c61 as println } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/io/console.mjs';
import { Duration5ynfiptaqcrg as Duration } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { decodeToString1x4faah2liw2p as decodeToString } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import {
  DataClientMessage3splhk6u8gldd as DataClientMessage,
  TextClientMessage15942w7lyj1yt as TextClientMessage,
} from '../ClientMessage.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function restartIdleTimeout($this) {
  var tmp0_safe_receiver = $this.m6i_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.rx();
  }
  var tmp = $this;
  tmp.m6i_1 = launch($this.l6i_1, VOID, VOID, SubscribableWebSocket$restartIdleTimeout$slambda_0($this));
}
function shutdownInternal($this, cause) {
  // Inline function 'kotlin.collections.mutableListOf' call
  var listeners = ArrayList().p2();
  // Inline function 'kotlinx.atomicfu.locks.withLock' call
  $this.k6i_1;
  if ($this.o6i_1.equals(SocketState_ShutDown_getInstance())) {
    return Unit_instance;
  }
  $this.o6i_1 = SocketState_ShutDown_getInstance();
  cancel($this.l6i_1);
  $this.p6i_1 = cause;
  listeners.u2($this.q6i_1.w4());
  $this.q6i_1.a5();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = listeners.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    element.c6j(cause);
  }
}
var SubscribableWebSocket$restartIdleTimeout$slambdaClass;
function SubscribableWebSocket$restartIdleTimeout$slambda() {
  if (SubscribableWebSocket$restartIdleTimeout$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.h6j_1 = this$0;
      }
      *k1g($this$launch, $completion) {
        yield* delay(this.h6j_1.j6i_1, $completion);
        this.h6j_1.i6j(ApolloNetworkException().b4b('WebSocket is idle'), 1001, 'Idle');
        return Unit_instance;
      }
      od(p1, $completion) {
        return this.k1g((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    SubscribableWebSocket$restartIdleTimeout$slambdaClass = $;
  }
  return SubscribableWebSocket$restartIdleTimeout$slambdaClass;
}
function SubscribableWebSocket$restartIdleTimeout$slambda_0(this$0) {
  var i = new (SubscribableWebSocket$restartIdleTimeout$slambda())(this$0);
  var l = ($this$launch, $completion) => i.k1g($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var SubscribableWebSocket$onOpen$slambdaClass;
function SubscribableWebSocket$onOpen$slambda() {
  if (SubscribableWebSocket$onOpen$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.j6j_1 = this$0;
      }
      *k1g($this$launch, $completion) {
        send(this.j6j_1.s6i_1, yield* this.j6j_1.g6i_1.y6g($completion));
        return Unit_instance;
      }
      od(p1, $completion) {
        return this.k1g((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    SubscribableWebSocket$onOpen$slambdaClass = $;
  }
  return SubscribableWebSocket$onOpen$slambdaClass;
}
function SubscribableWebSocket$onOpen$slambda_0(this$0) {
  var i = new (SubscribableWebSocket$onOpen$slambda())(this$0);
  var l = ($this$launch, $completion) => i.k1g($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var SubscribableWebSocket$onOpen$slambdaClass_0;
function SubscribableWebSocket$onOpen$slambda_1() {
  if (SubscribableWebSocket$onOpen$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0) {
        this.k6j_1 = this$0;
      }
      *k1g($this$launch, $completion) {
        yield* delay(this.k6j_1.i6i_1, $completion);
        this.k6j_1.i6j(ApolloNetworkException().b4b('Timeout while waiting for connection_ack'), 1001, 'Timeout while waiting for connection_ack');
        return Unit_instance;
      }
      od(p1, $completion) {
        return this.k1g((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    SubscribableWebSocket$onOpen$slambdaClass_0 = $;
  }
  return SubscribableWebSocket$onOpen$slambdaClass_0;
}
function SubscribableWebSocket$onOpen$slambda_2(this$0) {
  var i = new (SubscribableWebSocket$onOpen$slambda_1())(this$0);
  var l = ($this$launch, $completion) => i.k1g($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var SubscribableWebSocket$onMessage$slambdaClass;
function SubscribableWebSocket$onMessage$slambda() {
  if (SubscribableWebSocket$onMessage$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.l6j_1 = this$0;
      }
      *k1g($this$launch, $completion) {
        while (true) {
          yield* delay(this.l6j_1.h6i_1, $completion);
          var tmp0_safe_receiver = this.l6j_1.g6i_1.b6h();
          if (tmp0_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            send(this.l6j_1.s6i_1, tmp0_safe_receiver);
          }
        }
        return Unit_instance;
      }
      od(p1, $completion) {
        return this.k1g((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    SubscribableWebSocket$onMessage$slambdaClass = $;
  }
  return SubscribableWebSocket$onMessage$slambdaClass;
}
function SubscribableWebSocket$onMessage$slambda_0(this$0) {
  var i = new (SubscribableWebSocket$onMessage$slambda())(this$0);
  var l = ($this$launch, $completion) => i.k1g($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var SubscribableWebSocket$onMessage$slambdaClass_0;
function SubscribableWebSocket$onMessage$slambda_1() {
  if (SubscribableWebSocket$onMessage$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0) {
        this.m6j_1 = this$0;
      }
      *k1g($this$launch, $completion) {
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = this.m6j_1.r6i_1.p1();
        while (_iterator__ex2g4s.q1()) {
          var element = _iterator__ex2g4s.r1();
          send(this.m6j_1.s6i_1, yield* this.m6j_1.g6i_1.z6g(element, $completion));
        }
        return Unit_instance;
      }
      od(p1, $completion) {
        return this.k1g((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    SubscribableWebSocket$onMessage$slambdaClass_0 = $;
  }
  return SubscribableWebSocket$onMessage$slambdaClass_0;
}
function SubscribableWebSocket$onMessage$slambda_2(this$0) {
  var i = new (SubscribableWebSocket$onMessage$slambda_1())(this$0);
  var l = ($this$launch, $completion) => i.k1g($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var SubscribableWebSocket$startOperation$slambdaClass;
function SubscribableWebSocket$startOperation$slambda() {
  if (SubscribableWebSocket$startOperation$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $request) {
        this.n6j_1 = this$0;
        this.o6j_1 = $request;
      }
      *k1g($this$launch, $completion) {
        send(this.n6j_1.s6i_1, yield* this.n6j_1.g6i_1.z6g(this.o6j_1, $completion));
        return Unit_instance;
      }
      od(p1, $completion) {
        return this.k1g((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    SubscribableWebSocket$startOperation$slambdaClass = $;
  }
  return SubscribableWebSocket$startOperation$slambdaClass;
}
function SubscribableWebSocket$startOperation$slambda_0(this$0, $request) {
  var i = new (SubscribableWebSocket$startOperation$slambda())(this$0, $request);
  var l = ($this$launch, $completion) => i.k1g($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var SubscribableWebSocket$stopOperation$slambdaClass;
function SubscribableWebSocket$stopOperation$slambda() {
  if (SubscribableWebSocket$stopOperation$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $request) {
        this.p6j_1 = this$0;
        this.q6j_1 = $request;
      }
      *k1g($this$launch, $completion) {
        send(this.p6j_1.s6i_1, this.p6j_1.g6i_1.a6h(this.q6j_1));
        return Unit_instance;
      }
      od(p1, $completion) {
        return this.k1g((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    SubscribableWebSocket$stopOperation$slambdaClass = $;
  }
  return SubscribableWebSocket$stopOperation$slambdaClass;
}
function SubscribableWebSocket$stopOperation$slambda_0(this$0, $request) {
  var i = new (SubscribableWebSocket$stopOperation$slambda())(this$0, $request);
  var l = ($this$launch, $completion) => i.k1g($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var SubscribableWebSocketClass;
function SubscribableWebSocket() {
  if (SubscribableWebSocketClass === VOID) {
    class $ {
      constructor(webSocketEngine, serverUrl, httpHeaders, wsProtocol, pingInterval, connectionAcknowledgeTimeout, idleTimeout) {
        this.g6i_1 = wsProtocol;
        this.h6i_1 = pingInterval;
        this.i6i_1 = connectionAcknowledgeTimeout;
        this.j6i_1 = idleTimeout;
        var tmp = this;
        // Inline function 'kotlinx.atomicfu.locks.reentrantLock' call
        tmp.k6i_1 = get_atomicfu$reentrantLock();
        this.l6i_1 = CoroutineScope_0(Dispatchers_getInstance().l13_1);
        this.m6i_1 = null;
        this.n6i_1 = null;
        this.o6i_1 = SocketState_AwaitOpen_getInstance();
        this.p6i_1 = null;
        var tmp_0 = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp_0.q6i_1 = LinkedHashMap().ec();
        var tmp_1 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_1.r6i_1 = ArrayList().p2();
        var tmp_2;
        var tmp$ret$3;
        $l$block_0: {
          // Inline function 'kotlin.collections.any' call
          var tmp_3;
          if (isInterface(httpHeaders, Collection())) {
            tmp_3 = httpHeaders.n1();
          } else {
            tmp_3 = false;
          }
          if (tmp_3) {
            tmp$ret$3 = false;
            break $l$block_0;
          }
          var _iterator__ex2g4s = httpHeaders.p1();
          while (_iterator__ex2g4s.q1()) {
            var element = _iterator__ex2g4s.r1();
            // Inline function 'kotlin.text.lowercase' call
            // Inline function 'kotlin.js.asDynamic' call
            if (element.t4c_1.toLowerCase() === 'sec-websocket-protocol') {
              tmp$ret$3 = true;
              break $l$block_0;
            }
          }
          tmp$ret$3 = false;
        }
        if (tmp$ret$3) {
          tmp_2 = httpHeaders;
        } else {
          tmp_2 = plus(httpHeaders, new (HttpHeader())('Sec-WebSocket-Protocol', this.g6i_1.h1()));
        }
        var headers = tmp_2;
        this.s6i_1 = webSocketEngine.r6j(serverUrl, headers, this);
      }
      s6j(markActive) {
        // Inline function 'kotlinx.atomicfu.locks.withLock' call
        this.k6i_1;
        // Inline function 'kotlin.also' call
        var this_0 = this.o6i_1.equals(SocketState_ShutDown_getInstance());
        if (!this_0 && markActive) {
          var tmp0_safe_receiver = this.m6i_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.rx();
          }
          this.m6i_1 = null;
        }
        return this_0;
      }
      i6j(cause, code, reason) {
        shutdownInternal(this, cause);
        this.s6i_1.t6j(code, reason);
      }
      u6j() {
        // Inline function 'kotlinx.atomicfu.locks.withLock' call
        this.k6i_1;
        if (this.o6i_1.w1_1 === 0) {
          launch(this.l6i_1, VOID, VOID, SubscribableWebSocket$onOpen$slambda_0(this));
          var tmp = this;
          tmp.n6i_1 = launch(this.l6i_1, VOID, VOID, SubscribableWebSocket$onOpen$slambda_2(this));
          this.o6i_1 = SocketState_AwaitAck_getInstance();
        }
      }
      v6j(text) {
        var message = this.g6i_1.d6h(text);
        if (equals(message, ConnectionAckServerMessage_instance)) {
          var tmp0_safe_receiver = this.n6i_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.rx();
          }
          this.n6i_1 = null;
          // Inline function 'kotlinx.atomicfu.locks.withLock' call
          this.k6i_1;
          if (!this.o6i_1.equals(SocketState_AwaitAck_getInstance())) {
            return Unit_instance;
          }
          this.o6i_1 = SocketState_Connected_getInstance();
          var tmp = this.h6i_1;
          if (!((tmp == null ? null : new (Duration())(tmp)) == null)) {
            launch(this.l6i_1, VOID, VOID, SubscribableWebSocket$onMessage$slambda_0(this));
          }
          launch(this.l6i_1, VOID, VOID, SubscribableWebSocket$onMessage$slambda_2(this));
        } else {
          if (message instanceof ConnectionErrorServerMessage()) {
            this.i6j(SubscriptionConnectionException().r4i(message.w6j_1), 1001, 'Connection error');
          } else {
            if (message instanceof ResponseServerMessage()) {
              // Inline function 'kotlinx.atomicfu.locks.withLock' call
              this.k6i_1;
              var tmp1_safe_receiver = this.q6i_1.u4(message.e6h_1);
              if (tmp1_safe_receiver == null)
                null;
              else {
                tmp1_safe_receiver.y6i(message.f6h_1);
              }
            } else {
              if (message instanceof CompleteServerMessage()) {
                // Inline function 'kotlinx.atomicfu.locks.withLock' call
                this.k6i_1;
                var tmp2_safe_receiver = this.q6i_1.u4(message.g6h_1);
                if (tmp2_safe_receiver == null)
                  null;
                else {
                  tmp2_safe_receiver.a6j();
                }
              } else {
                if (message instanceof OperationErrorServerMessage()) {
                  // Inline function 'kotlinx.atomicfu.locks.withLock' call
                  this.k6i_1;
                  var tmp3_safe_receiver = this.q6i_1.u4(message.h6h_1);
                  if (tmp3_safe_receiver == null)
                    null;
                  else {
                    tmp3_safe_receiver.b6j(message.i6h_1);
                  }
                } else {
                  if (message instanceof ParseErrorServerMessage()) {
                    println("Cannot parse message: '" + message.j6h_1 + "'");
                  } else {
                    if (equals(message, PingServerMessage_instance)) {
                      var tmp4_safe_receiver = this.g6i_1.c6h();
                      if (tmp4_safe_receiver == null)
                        null;
                      else {
                        // Inline function 'kotlin.let' call
                        send(this.s6i_1, tmp4_safe_receiver);
                      }
                    } else {
                      if (!equals(message, PongServerMessage_instance)) {
                        if (!equals(message, ConnectionKeepAliveServerMessage_instance)) {
                          noWhenBranchMatchedException();
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      x6j(data) {
        this.v6j(decodeToString(data));
      }
      y6j(cause) {
        shutdownInternal(this, cause);
      }
      z6j(code, reason) {
        shutdownInternal(this, ApolloWebSocketClosedException().r4h(code == null ? 1001 : code, reason));
      }
      t6i(request, listener) {
        var cause = null;
        // Inline function 'kotlinx.atomicfu.locks.withLock' call
        this.k6i_1;
        var tmp0_safe_receiver = this.m6i_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.rx();
        }
        this.m6i_1 = null;
        var tmp;
        switch (this.o6i_1.w1_1) {
          case 0:
          case 1:
            this.q6i_1.x4(request.s44_1.toString(), listener);
            tmp = this.r6i_1.i2(request);
            break;
          case 2:
            this.q6i_1.x4(request.s44_1.toString(), listener);
            tmp = launch(this.l6i_1, VOID, VOID, SubscribableWebSocket$startOperation$slambda_0(this, request));
            break;
          case 3:
            cause = DefaultApolloException().n46('Apollo: the WebSocket is shut down', this.p6i_1);
            tmp = Unit_instance;
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        if (!(cause == null)) {
          listener.c6j(ensureNotNull(cause));
        }
      }
      u6i(request) {
        var id = request.s44_1.toString();
        // Inline function 'kotlinx.atomicfu.locks.withLock' call
        this.k6i_1;
        if (this.q6i_1.s4(id)) {
          this.q6i_1.y4(id);
          launch(this.l6i_1, VOID, VOID, SubscribableWebSocket$stopOperation$slambda_0(this, request));
          if (this.q6i_1.n1()) {
            restartIdleTimeout(this);
          }
        }
      }
    }
    initMetadataForClass($, 'SubscribableWebSocket');
    SubscribableWebSocketClass = $;
  }
  return SubscribableWebSocketClass;
}
var SocketState_AwaitOpen_instance;
var SocketState_AwaitAck_instance;
var SocketState_Connected_instance;
var SocketState_ShutDown_instance;
var SocketState_entriesInitialized;
function SocketState_initEntries() {
  if (SocketState_entriesInitialized)
    return Unit_instance;
  SocketState_entriesInitialized = true;
  SocketState_AwaitOpen_instance = new (SocketState())('AwaitOpen', 0);
  SocketState_AwaitAck_instance = new (SocketState())('AwaitAck', 1);
  SocketState_Connected_instance = new (SocketState())('Connected', 2);
  SocketState_ShutDown_instance = new (SocketState())('ShutDown', 3);
}
var SocketStateClass;
function SocketState() {
  if (SocketStateClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'SocketState');
    SocketStateClass = $;
  }
  return SocketStateClass;
}
function send(_this__u8e3s4, clientMessage) {
  if (clientMessage instanceof TextClientMessage()) {
    _this__u8e3s4.c6k(clientMessage.u6g_1);
  } else {
    if (clientMessage instanceof DataClientMessage()) {
      _this__u8e3s4.b6k(clientMessage.a6k_1);
    } else {
      noWhenBranchMatchedException();
    }
  }
}
function SocketState_AwaitOpen_getInstance() {
  SocketState_initEntries();
  return SocketState_AwaitOpen_instance;
}
function SocketState_AwaitAck_getInstance() {
  SocketState_initEntries();
  return SocketState_AwaitAck_instance;
}
function SocketState_Connected_getInstance() {
  SocketState_initEntries();
  return SocketState_Connected_instance;
}
function SocketState_ShutDown_getInstance() {
  SocketState_initEntries();
  return SocketState_ShutDown_instance;
}
//region block: exports
export {
  SubscribableWebSocket as SubscribableWebSockethkxzhdarcovi,
};
//endregion

//# sourceMappingURL=SubscribableWebSocket.mjs.map
